var _style, _g, _g2, _rect, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 792 216",
    style: {
      enableBackground: "new 0 0 792 216"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{display:none;}\n\t.st1{display:inline;}\n\t.st2{fill:none;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bg",
    className: "st0"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    width: 792,
    height: 216
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M444.4,143.9V83.2H410V71.9h81.7v11.3h-34.4v60.7L444.4,143.9L444.4,143.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.6,114.5c-8.3,6.2-17.9,6.4-35.9,6.4l-26.7-0.3v23.3h-13v-72l41.6,0.3c15.4,0,26.4-0.6,33.7,5 c5.6,4.1,5.9,11.5,5.9,18.9S303.1,110.4,297.6,114.5z M267.2,81.6L235,81.3v30.1l32.4,0.3c19.5,0,24.3-3.2,24.3-15.2 C291.7,83.1,284.3,81.6,267.2,81.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.1,138.1c-7.7-5.4-9.2-12.4-9.2-24.3V71.9H329V113c0,7.5,0.9,11.5,5.9,15.6c4.9,4.2,13.1,3.8,21.9,3.8 c8.5,0,16.9,0.5,22-3.7c5-4,5.8-7.9,5.8-15.4V71.9h12.8v41.9c0,11.8-1.6,19-9.3,24.4c-8.7,6.1-20.4,5.6-31.5,5.6 C345.3,143.9,333.7,144.2,325.1,138.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.5,143.9V83.2H504V71.9h81.7v11.3h-34.4v60.7L538.5,143.9L538.5,143.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M663.9,143.9l-23.1-27c-3.5,0-4.8,0-7.3,0h-22.4v27h-13v-72h37.5c15.4,0,25.7-0.6,33.2,4.4c5.4,3.7,6.4,10.4,6.4,17.6 c0,7.1-0.7,13.9-6.2,17.8c-3.4,2.7-8,3.1-13.8,3.6l24.6,28.5h-15.9V143.9z M639.5,81.3h-28.4v26.5h28.5c17.7,0,24.1-1.7,24.1-13.4 C663.6,82.3,655.9,81.3,639.5,81.3z"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 688.9,
    y: 64.6,
    className: "st2",
    width: 24.9,
    height: 18.2
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "logo"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M120,55.7L120,55.7c-1.9,0-3.4-1.5-3.4-3.4V24.4c0-1.9,1.5-3.4,3.4-3.4l0,0c1.9,0,3.4,1.5,3.4,3.4v27.9 C123.4,54.2,121.9,55.7,120,55.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137,37v7c27.8,7.5,48.2,32.9,48.2,63c0,36-29.2,65.2-65.2,65.2S54.7,143,54.7,106.9c0-30.1,20.4-55.4,48.1-63v-7 C71.3,44.7,48,73.1,48,106.9c0,39.8,32.2,72,72,72s72-32.2,72-72C192,73,168.5,44.6,137,37z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 108,
    r: 17
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M156.9,144.9c-5.4,5.4-9.2,7.1-9.2,7.1c-2.6,1.2-5.6,0.7-7.7-3c-2.1-3.7-5.3-12.4-6-14.7s0.1-4,2.2-6c1.2-1.2,2-2,2-2 s0.8-0.8,2-2c2-2.1,3.7-2.8,6-2.2s11,3.9,14.7,6c3.7,2.1,4.3,5.1,3,7.7C164,135.8,162.3,139.5,156.9,144.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.1,71.1c-5.4,5.4-7.1,9.2-7.1,9.2c-1.2,2.6-0.7,5.6,3,7.7s12.4,5.3,14.7,6c2.3,0.7,4-0.1,6-2.2c1.2-1.2,2-2,2-2 s0.8-0.8,2-2c2.1-2,2.8-3.7,2.2-6c-0.7-2.3-3.9-11-6-14.7c-2.1-3.7-5.1-4.3-7.7-3C92.2,64,88.5,65.7,83.1,71.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.8,71c5.4,5.4,7.1,9.2,7.1,9.2c1.2,2.6,0.7,5.6-3,7.7s-12.4,5.3-14.7,6s-4-0.1-6-2.2c-1.2-1.2-2-2-2-2s-0.8-0.8-2-2 c-2.1-2-2.8-3.7-2.2-6s3.9-11,6-14.7c2.1-3.7,5.1-4.3,7.7-3C147.7,63.9,151.4,65.6,156.8,71z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83,144.8c5.4,5.4,9.2,7.1,9.2,7.1c2.6,1.2,5.6,0.7,7.7-3s5.3-12.4,6-14.7s-0.1-4-2.2-6c-1.2-1.2-2-2-2-2s-0.8-0.8-2-2 c-2-2.1-3.7-2.8-6-2.2s-11,3.9-14.7,6c-3.7,2.1-4.3,5.1-3,7.7C75.9,135.7,77.6,139.4,83,144.8z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoDark);
export default __webpack_public_path__ + "static/media/logo_dark.d9c17b4cc6baaa365e7e018d4a5b876d.svg";
export { ForwardRef as ReactComponent };